export default __webpack_public_path__ + "static/media/coin-circle-fill.9e607125.svg";